export const translationNavigation_en_part1 = {
  conversations: "Conversations",
  uploadData: "Upload Data",
  behaviourStudio: "Behavior",
  missingInfoTickets: "Missing Info",
  statistics: "Statistics",
  logout: "Logout",
  profileSettings: "Profile settings",
  profileSettingsDescription: "Manage your language, email notifications, and appearance.",
  languageLabel: "Language",
  languageSystem: "System",
  languageEnglish: "English",
  languageDanish: "Danish",
  allChatbots: "All Chatbots",
  Chatbot: "Chatbot",
  widgetUi: "Widget UI",
  users: "Users",
  solutions: "Solutions",
  developer: "Developer",
  connectAi: "MCP Connect",
  integrations: "Integrations",
  organizations: "Organizations",
  livechat: "Livechat",
  mentionNotificationsNavBadge: "Unread mentions for you",
  mentionToastTitle: "You were mentioned",
  mentionToastBody: "Someone mentioned you in a conversation.",
  mentionToastOpen: "Open conversation",
  notificationClose: "Close notification",
  livechatNotificationToast: "New live chat activity",
  livechatNotificationToastOpen: "Open live chat",
  livechatNotificationOsTitle: "Live chat",
  livechatNotificationOsBody: "New live chat activity is waiting for you.",
  customerOverview: "Financial overview",
  productAnalytics: "Product analytics",
  testPortals: "Test Portals",

  // Financial overview (/revenue)

  // Financial overview (/revenue)
  financialOverviewDescriptionBefore:
    "MRR is calculated as the running sum of all payment events per organization (",
  financialOverviewDescriptionAfter:
    "). The chart shows monthly delta and accumulated MRR over the last 12 months.",
  financialOverviewRefresh: "Refresh",
  financialOverviewFetchError: "Could not load data",
  financialOverviewChartTotalMrrLegend: "Total MRR (running sum)",
  financialOverviewChartDeltaLegend: "Change in month (delta)",
  financialOverviewChartGoalLegend: "MRR goal",
  financialOverviewChartTab: "Overview",
  financialOverviewGoalsTab: "Goal settings",
  financialOverviewGoalsDescription:
    "Set an MRR goal for each month. Saved goals appear as a dashed line in the chart.",
  financialOverviewGoalsSave: "Save goals",
  financialOverviewChartYTitleMrr: "MRR (DKK)",
  financialOverviewChartYTitleDelta: "Delta (DKK)",
  financialOverviewKpiTotalMrr: "Total MRR",
  financialOverviewKpiPayingOrgs: "Paying organizations",
  financialOverviewKpiAvgMrrPaying: "Avg. MRR (paying)",
  financialOverviewKpiLatestMonth: "Latest month",
  financialOverviewKpiDeltaSublabel: "Delta in calendar month",
  financialOverviewMrrOverTime: "MRR over time",
  financialOverviewNoMonthlySeries: "No monthly series yet.",
  financialOverviewOrganizations: "Organizations",
  financialOverviewRowCount: "{count} rows",
  financialOverviewColOrganization: "Organization",
  financialOverviewColCurrentMrr: "Current MRR",
  financialOverviewColConversationsLast30Days: "Conversations (30 days)",
  financialOverviewColPricePerConversation: "Price/conversation",
  financialOverviewColDetails: "Details",
  financialOverviewCtaBusiness: "Business",
  financialOverviewNoOrgsFound: "No organizations found.",
  financialOverviewNoMatchingOrgs: "No organizations match your search or filters.",
  financialOverviewSearchPlaceholder: "Search organizations…",
  financialOverviewSearchAriaLabel: "Search organizations by name or Keycloak id",
  financialOverviewFilterPayingOnly: "Paying only",
  financialOverviewRowCountFiltered: "{filtered} of {total} rows",
  financialOverviewMissingKeycloakTitle: "Missing Keycloak organization id",
  financialOverviewTooltipPaymentEvents: "Payment events",
  financialOverviewTooltipNoEvents: "No payment events this month",
  financialOverviewEventTypeIncrease: "Increase",
  financialOverviewEventTypeDecrease: "Decrease",
  financialOverviewEventTypeChurn: "Churn",

  // Scope picker (sidebar — org / brand / chatbot)

  // Scope picker (sidebar — org / brand / chatbot)
  scopePickerAllChatbots: "All chatbots",
  scopePickerAllCustomers: "All customers",
  scopePickerSearchPlaceholder: "Search (press / to focus)",
  scopePickerRecent: "Recent",
  scopePickerNoChatbots: "No chatbots available",
  scopePickerChatbotCountOne: "1 chatbot",
  scopePickerChatbotCountMany: "{n} chatbots",
  scopePickerExpand: "Expand",
  scopePickerCollapse: "Collapse",
  scopePickerOrgUnavailable: "(organization unavailable)",
  scopePickerBrandUnavailable: "(brand unavailable)",

  // Test chatbot widget (floating picker in the dashboard)

  // Test chatbot widget (floating picker in the dashboard)
  testChatbotTesting: "Testing",
  testChatbotChoose: "Choose a chatbot",
  testChatbotAuto: "Auto (follows selected scope)",
  testChatbotSearchPlaceholder: "Search chatbots...",
  testChatbotNoResults: "No chatbots match",
  testChatbotHide: "Hide widget",
  testChatbotShow: "Show test chatbot",

  agentNamePlaceholder: "Enter your agent name",
  livechatConversations: "Conversations",
  livechatSettings: "Settings",
  goToLivechat: "Go to livechat",
  livechatAvailable: "This conversation is available in livechat mode...",

  // Chatbot configuration translations

  // Chatbot configuration translations
  themeColor: "Primary color",
  darkMode: "Dark mode",
  enableDarkMode: "Enable dark mode",
  lightModeTab: "Light",
  darkModeTab: "Dark",
  darkModePreviewHint:
    "The live preview shows light mode. Dark mode is delivered through the chatbot API.",
  backgroundColor: "Chat background",
  backgroundGradientColor: "Background gradient",
  headerButtonBackgroundColor: "Header button background",
  headerButtonIconColor: "Header button icon",
  secondaryTextColor: "Muted text",
  aiMessageColor: "Assistant message",
  aiMessageTextColor: "Assistant message text",
  aiMessageBorderColor: "Assistant message border",
  aiMessageThinkingBorderGradient: "Assistant thinking border",
  addGradientStop: "Add gradient stop",
};
